import { userLogout } from "../../services/authorization/service";
import { logoutUser, updateUser } from "../actions/authActions";
import { updateUserLoginState } from "../../services/authorization/Authorization";
import { hideLoading } from "../../shared/widgets/bar-loader/src";
import { createAllActionCreators } from "./actionCreatorUtil";

const autheritiesActionCreators = {
  userLogoutAction: {
    service: userLogout,
    responseFn: (response, params) => {
      const { dispatch } = params;
      dispatch(hideLoading("header"));
      dispatch(logoutUser(null));
      dispatch(updateUser({}));
      updateUserLoginState(null);
    },
  },
};

export const { userLogoutAction } = createAllActionCreators(
  autheritiesActionCreators,
);
